import axios from 'axios';
import router from '../router';


/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
    // 状态码判断
    switch (status) {
        // 404请求不存在
        case 404:
            break;
        default:
            console.log(other);
        }}

// 创建axios实例
var instance = axios.create({timeout: 1000 * 12});
// 设置post请求头
//instance.defaults.headers.post['Content-Type'] = 'application/json';
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
    config => {
        return config;
    },
    error => Promise.error(error))

// 响应拦截器
instance.interceptors.response.use(
    // 请求成功
    res =>{
      if(res.status === 200){
        if(res.data.code == 401){
            errorHandle(res.data.code,"");
			return Promise.reject(res.data)
        }else{
          return Promise.resolve(res.data);
        }

      }else{
        return Promise.reject(res.data)
      }
    },
    // 请求失败
    error => {
        const { response } = error;
        if (response) {
            // 请求已发出，但是不在2xx的范围
            if(response.data.code == 401){
                errorHandle(response.data.code,"");
            }else{
              return Promise.resolve(response.data);
            }
        }
    });

export default instance;
